import { render, staticRenderFns } from "./Aiclass.vue?vue&type=template&id=4aa44f73&scoped=true&"
import script from "./Aiclass.vue?vue&type=script&lang=js&"
export * from "./Aiclass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa44f73",
  null
  
)

export default component.exports